import Config from 'utils/getEnvConfig';
import axios from 'axios';
import _get from 'lodash/get';
import { getLocalData } from 'utils/localDataStore';

const {
  LAMBDA: {
    SUBSCRIPTION: {
      ASSESSMENT_TAKEN,
      GET_SUBSCRIPTION_URL,
      DO_SUBSCRIPTION_URL,
      UNSUBSCRIBE_URL,
      API_KEY,
    },
  },
} = Config;

const NON_EMAIL_SUBSCRIPTIONS = ['customconsent', 'emailSubscription'];

const filterEmailSubscriptions = contentList => {
  if (!Array.isArray(contentList)) return [];
  return contentList.filter(item => {
    if (!item) return false;
    if (NON_EMAIL_SUBSCRIPTIONS.includes(item)) return false;
    if (typeof item !== 'string') return false;
    return true;
  });
};

const getUserStatus = email =>
  axios.get(`${GET_SUBSCRIPTION_URL}${email}`, {
    headers: {
      'x-api-key': API_KEY,
    },
  });

const subscribe = ({
  email,
  subscription,
  firstName,
  lastName,
  isSamlProvider,
  clientSubbrand,
}) => {
  const brand = getLocalData('brand') || 'none';
  const emailSubscriptions = filterEmailSubscriptions(subscription);

  return axios
    .post(
      DO_SUBSCRIPTION_URL,
      {
        email,
        brand,
        contentList: emailSubscriptions,
        firstName,
        lastName,
        saml: isSamlProvider,
        subbrand: clientSubbrand,
      },
      {
        headers: {
          'x-api-key': API_KEY,
        },
      },
    )
    .then(
      response =>
        new Promise((resolve, reject) => {
          if (response.status >= 200 && response.status < 300) {
            resolve(response);
          } else {
            reject(response);
          }
        }),
    )
    .catch(
      error =>
        new Promise((_, reject) => {
          reject(_get(error, 'response'));
        }),
    );
};

const updateSubscription = ({
  email,
  contentList,
  firstName,
  lastName,
  oldEmail,
  clientSubbrand,
}) => {
  const brand = getLocalData('brand') || 'none';
  const emailSubscriptions = filterEmailSubscriptions(contentList);

  return axios
    .put(
      DO_SUBSCRIPTION_URL,
      {
        email,
        brand,
        contentList: emailSubscriptions,
        firstName,
        lastName,
        oldEmail,
        subbrand: clientSubbrand,
      },
      {
        headers: {
          'x-api-key': API_KEY,
        },
      },
    )
    .then(
      response =>
        new Promise((resolve, reject) => {
          if (response.status >= 200 && response.status < 300) {
            resolve(response);
          } else {
            reject(response);
          }
        }),
    )
    .catch(
      error =>
        new Promise((_, reject) => {
          reject(_get(error, 'response'));
        }),
    );
};

const patchSubscriptionBrand = ({ email, clientSubbrand }) => {
  const brand = getLocalData('brand') || 'none';
  return axios
    .patch(
      DO_SUBSCRIPTION_URL,
      {
        email,
        brand,
        subbrand: clientSubbrand,
      },
      {
        headers: {
          'x-api-key': API_KEY,
        },
      },
    )
    .then(
      response =>
        new Promise((resolve, reject) => {
          if (
            (response.status >= 200 && response.status < 300) ||
            response.status === 404
          ) {
            resolve(response);
          } else {
            reject(response);
          }
        }),
    )
    .catch(
      error =>
        new Promise((resolve, reject) => {
          if (_get(error, 'response.status') === 404) {
            resolve();
          } else {
            reject(_get(error, 'response'));
          }
        }),
    );
};

const unsubscribe = email =>
  axios.post(
    UNSUBSCRIBE_URL,
    {
      email,
    },
    {
      headers: {
        'x-api-key': API_KEY,
      },
    },
  );

const patchAssessmentTaken = (email, slug) =>
  axios.patch(
    ASSESSMENT_TAKEN,
    {
      email,
      slug,
    },
    {
      headers: {
        'x-api-key': API_KEY,
      },
    },
  );

const sendTookAssessmentTag = ({ email, timestamp }) => {
  const brand = getLocalData('brand') || 'none';
  const payload = {
    email,
    brand,
    tags: ['assessment-taken'],
    fieldValues: {
      TOOK_ASSESSMENT_DATE: timestamp,
    },
  };

  return axios
    .post(DO_SUBSCRIPTION_URL, payload, {
      headers: {
        'x-api-key': API_KEY,
      },
    })
    .then(
      response =>
        new Promise((resolve, reject) => {
          if (response.status >= 200 && response.status < 300) {
            resolve(response);
          } else {
            reject(response);
          }
        }),
    )
    .catch(
      error =>
        new Promise((_, reject) => {
          reject(_get(error, 'response'));
        }),
    );
};

export default {
  getUserStatus,
  subscribe,
  updateSubscription,
  patchSubscriptionBrand,
  patchAssessmentTaken,
  sendTookAssessmentTag,
  unsubscribe,
};
